import { render, staticRenderFns } from "./FollowUpCategory.vue?vue&type=template&id=7abac9fa&scoped=true"
import script from "./FollowUpCategory.vue?vue&type=script&lang=js"
export * from "./FollowUpCategory.vue?vue&type=script&lang=js"
import style0 from "./FollowUpCategory.vue?vue&type=style&index=0&id=7abac9fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7abac9fa",
  null
  
)

export default component.exports